import React from 'react';
import { Paper, Table, TableHead, TableRow, TableCell, TableBody, TableContainer, Chip, Skeleton } from '@mui/material';
import { PatientStatus } from '../Data/enums';

const statusColor = (s) =>
  s === PatientStatus.DISCHARGED ? 'success' :
  s === PatientStatus.EMERGENCY  ? 'error'   : 'info';

export default function MedsExternalTable({ items = [], loading }) {
  if (loading) return <Skeleton variant="rounded" height={260} />;
  return (
    <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 400, overflow: 'auto' }}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow sx={{ '& th': { backgroundColor: '#607d8b', color: '#fff', fontWeight: 'bold' } }}>
            <TableCell>Medication</TableCell>
            <TableCell>Dose</TableCell>
            <TableCell>Route</TableCell>
            <TableCell>Frequency</TableCell>
            <TableCell>Source</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((m, idx) => (
            <TableRow
              key={m.id}
              sx={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#f5f5f5', '&:hover': { backgroundColor: '#e3f2fd' } }}
            >
              <TableCell>{m.name}</TableCell>
              <TableCell>{m.dose}</TableCell>
              <TableCell>{m.route}</TableCell>
              <TableCell>{m.frequency}</TableCell>
              <TableCell><Chip size="small" label={m.source} color={statusColor(m.source)} /></TableCell>
            </TableRow>
          ))}
          {items.length === 0 && (
            <TableRow>
              <TableCell colSpan={5} align="center">No external medications</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
